<app-header-lite></app-header-lite>
<main class="content-container"><app-global-info [message]="bannedMessage"></app-global-info></main>
